var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDevelopment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.039,
    y: 97.251,
    width: 122.5,
    height: 30.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.148,
    y: 142.232,
    width: 122.5,
    height: 30.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.039,
    y: 187.212,
    width: 122.5,
    height: 30.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.148,
    y: 232.193,
    width: 122.5,
    height: 30.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.039,
    y: 277.166,
    width: 122.5,
    height: 30.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.969,362.717h183.75v52.951h-69.863v30.625h216.289v-30.625h-69.863v-52.951h183.75 c12.633,0,22.969-10.336,22.969-22.969V66.676c0-12.633-10.336-22.969-22.969-22.969H22.969C10.336,43.707,0,54.043,0,66.676 v273.073C0,352.381,10.336,362.717,22.969,362.717z M30.625,74.332h428.75v257.76H30.625V74.332z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment1);
export default __webpack_public_path__ + "static/media/webDevelopment1.efc8bb9755403fa8c717b03c34b9e4f5.svg";
export { ForwardRef as ReactComponent };